type CountryDataMap = {
  code: string[];
  countryName: string;
  countryIconPath: string;
};

const COUNTRIES: CountryDataMap[] = [
  {
    code: ['ARG', 'AR'],
    countryName: 'Argentina',
    countryIconPath: 'assets/icons/countries/icon-ar.svg',
  },
  {
    code: ['CHL', 'CL'],
    countryName: 'Chile',
    countryIconPath: 'assets/icons/countries/icon-cl.svg',
  },
  {
    code: ['COL', 'CO'],
    countryName: 'Colombia',
    countryIconPath: 'assets/icons/countries/icon-co.svg',
  },
  {
    code: ['DEU', 'DE'],
    countryName: 'Alemania',
    countryIconPath: 'assets/icons/countries/icon-de.svg',
  },
  {
    code: ['ECU', 'EC'],
    countryName: 'Ecuador',
    countryIconPath: 'assets/icons/countries/icon-ec.svg',
  },
  {
    code: ['ESP', 'ES'],
    countryName: 'España',
    countryIconPath: 'assets/icons/countries/icon-es.svg',
  },
  {
    code: ['FRA', 'FR'],
    countryName: 'Francia',
    countryIconPath: 'assets/icons/countries/icon-fr.svg',
  },
  {
    code: ['ITA', 'IT'],
    countryName: 'Italia',
    countryIconPath: 'assets/icons/countries/icon-it.svg',
  },
  {
    code: ['MEX', 'MX'],
    countryName: 'México',
    countryIconPath: 'assets/icons/countries/icon-mx.svg',
  },
  {
    code: ['NLD', 'NL'],
    countryName: 'Países Bajos',
    countryIconPath: 'assets/icons/countries/icon-nl.svg',
  },
  {
    code: ['PER', 'PE', 'PEN'],
    countryName: 'Perú',
    countryIconPath: 'assets/icons/countries/icon-pe.svg',
  },
  {
    code: ['PRT', 'PT'],
    countryName: 'Portugal',
    countryIconPath: 'assets/icons/countries/icon-pt.svg',
  },
  {
    code: ['USA', 'US', 'USD'],
    countryName: 'Estados Unidos',
    countryIconPath: 'assets/icons/countries/icon-us.svg',
  },
];

export function retrieveCountryByCode(code: string): CountryDataMap {
  const country = COUNTRIES.find(c => c.code.includes(code));
  if (country == null) return {
    code: [code],
    countryName: 'none',
    countryIconPath: 'assets/icons/countries/icon-none.svg',
  };

  
  return country;
}
